module.exports = __webpack_public_path__ + "img/omocha.f1175199.jpg";